import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { scheduleQKeys } from "@hooks/queries/schedule/queryKeys";


interface MutationProps {
  appointmentId: string;
  rejectionReason: string;
}

export const useRejectAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId, rejectionReason }: MutationProps) => {
      return api.patch(`appointments/${appointmentId}/reject`, { rejection_reason: rejectionReason });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: consultationQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Reject Appointment]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },
  });
};
